import { defineMessages } from 'react-intl';

export default defineMessages({
  allocationStrategiesHeader: {
    description: 'settings > allocation strategies header',
    defaultMessage: 'Allocation Strategy',
    id: '4XAQcW',
  },
  allocationStrategiesDescription: {
    description: 'settings > allocation strategies description',
    defaultMessage:
      'Allocation refers to the process of reserving inventory for orders based on priority. You can customize this process by creating steps (or Tasks) and specifying how priority is given to orders in each set.',
    id: 'ecgQsW',
  },
  allocationStrategiesTask: {
    description: 'settings > allocation strategies task header',
    defaultMessage: 'Allocation Task',
    id: '25q/Gs',
  },
  allocationStrategiesPrioritize: {
    description: 'settings > allocation strategies prioritize header',
    defaultMessage: 'Prioritize',
    id: 'malXII',
  },
  allocationStrategiesFirst: {
    description: 'settings > allocation strategies first header',
    defaultMessage: 'First...',
    id: 'fU6N29',
  },
  allocationStrategiesThen: {
    description: 'settings > allocation strategies then header',
    defaultMessage: 'Then...',
    id: 'SQ8jnF',
  },
  allocationStrategiesHighestOrderTotal: {
    description: 'settings > allocation strategies Highest Order Total',
    defaultMessage: 'Highest Order Total',
    id: '3RLG1n',
  },
  allocationStrategiesLowestOrderTotal: {
    description: 'settings > allocation strategies Lowest Order Total',
    defaultMessage: 'Lowest Order Total',
    id: 'SKe97q',
  },
  allocationStrategiesNewestOrders: {
    description: 'settings > allocation strategies Newest Orders',
    defaultMessage: 'Newest Orders',
    id: 'yYG7RB',
  },
  allocationStrategiesOldestOrders: {
    description: 'settings > allocation strategies Oldest Orders',
    defaultMessage: 'Oldest Orders',
    id: 'wHhMVK',
  },
  allocationStrategiesOldestFirst: {
    description: 'settings > allocation strategies first indicator',
    defaultMessage: 'First...',
    id: 'mKBoT8',
  },
  allocationStrategiesOldestThen: {
    description: 'settings > allocation strategies first indicator',
    defaultMessage: 'Then...',
    id: 'n6guA3',
  },
  allocationStrategiesEdit: {
    description: 'settings > allocation strategies edit button',
    defaultMessage: 'Edit',
    id: 'DZKuV/',
  },
  allocationStrategiesRemove: {
    description: 'settings > allocation strategies remove button',
    defaultMessage: 'Remove',
    id: 'ZMB0EF',
  },
  allocationStrategiesRemoveConfirmation: {
    description: 'settings > allocation strategies remove confirmation message',
    defaultMessage: 'Are you sure you want to delete this inventory allocation task?',
    id: 'SdJa13',
  },
  allocationStrategiesSave: {
    description: 'settings > allocation strategies rule Save',
    defaultMessage: 'Save',
    id: '30fNve',
  },
  allocationStrategiesCancel: {
    description: 'settings > allocation strategies rule Cancel',
    defaultMessage: 'Cancel',
    id: 'CtNbOt',
  },
  allocationStrategiesTagName: {
    description: 'settings > allocation strategies rule tagged as',
    defaultMessage: 'Allocate orders tagged as',
    id: '+t63Om',
  },
  allocationStrategiesOrderPlaced: {
    description: 'settings > allocation strategies rule order placed',
    defaultMessage: 'Allocate orders older than <a>{value}</a> days old',
    id: 'vHs4cn',
  },
  allocationStrategiesOrderMarketplace: {
    description: 'settings > allocation strategies rule orders from marketplace',
    defaultMessage: 'Allocate orders from <b>{storeName}</b>',
    id: '0pqPg3',
  },
  allocationStrategiesAddRule: {
    description: 'settings > allocation strategies add rule button',
    defaultMessage: 'Then allocate orders...',
    id: 'LL9Ppa',
  },
  noRulesCreated: {
    description: 'settings > allocation strategies no rules added yet',
    defaultMessage: 'Click here to start adding allocation rules...',
    id: 'UFJsHh',
  },
  allocationStrategiesAddMarketplaceRule: {
    description: 'settings > allocation strategies add marketplace rule button',
    defaultMessage: 'From a Marketplace...',
    id: 'K8aGXo',
  },
  allocationStrategiesAddTagRule: {
    description: 'settings > allocation strategies add tag rule button',
    defaultMessage: 'Tagged as...',
    id: 'MnjZbM',
  },
  allocationStrategiesAddAgeRule: {
    description: 'settings > allocation strategies add age rule button',
    defaultMessage: 'Older than...',
    id: '/MM/6x',
  },
  allocationStrategiesAddAdvancedRule: {
    description: 'settings > allocation strategies add advanced rule button',
    defaultMessage: 'Advanced...',
    id: 'xdk20E',
  },
  allocationStrategiesAdditionalInfo: {
    description: 'settings > allocation strategies additional information',
    defaultMessage: 'Orders that are not addressed by the above tasks will be allocated with <b>priority given to oldest orders</b>',
    id: 'g7SPjz',
  },
  allocationStrategiesErrorMessage: {
    description: 'settings > allocation strategies error occurred messaging',
    defaultMessage: "We're sorry but an error occurred. Please try again.",
    id: 'EtrS3i',
  },
  allocationStrategiesKBLink: {
    description: 'settings > allocation strategies knowledge base article link',
    defaultMessage: 'For allocation strategy ideas, <a>click here.</a>',
    id: 'GW46BV',
  },
});
